import { Box, Skeleton } from '@mui/material';
import { memo } from 'react';

export const ReportWidgetTableLoading = memo(() => (
    <Box
        data-testclass="composable-report-widget-table"
        sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '12px',
            overflow: 'hidden',
        }}
    >
        <Skeleton variant="rectangular" height={200} sx={{ width: '100%' }} />
    </Box>
));
